import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import TeamProp from '../../../commonComponents/propTypes/teamProp';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';

function TabTarget({ t, accessSession, createInput, createUserMultiple, selectMultiple, teams, selectTags }) {
  return (
    <>
      {accessSession.mode === 'public' &&
        <div>
          {createInput('minUsers', 'text', false, 'col-3 text-right', 'col-5')}
          {createInput('maxUsers', 'text', false, 'col-3 text-right', 'col-5')}
        </div>
      }
      {accessSession.mode === 'private' &&
      <div className="tab3-target row">
        <div className="col-lg-6">
          <div className="col-lg-12 block-target">
            {createUserMultiple('targetUsers', 'col-3 text-right', 'col-9 row no-gutters')}
          </div>
          <div id="tabTarget-emails-container" className="col-lg-12 block-target">
            {selectTags('emails')}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="col-lg-12 block-target">
            {selectMultiple(
              'targetTeams',
              teams.map(c => ({ id: c._id, text: c.name })),
              'col-3 text-right',
              'col-8',
            )}
          </div>
          <div className="col-12 text-left block-target">
            <div className="row">
              <div className="col-2 text-right">
                <i className="fas fa-info-circle block-target-icon" />
              </div>
              <div className="col">
                <span>{t('access_session.block_target.hint')}</span>
                <br />
                <span>{t('access_session.block_target.hint_2')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </>
  );
}

TabTarget.propTypes = {
  t: PropTypes.func.isRequired,
  accessSession: PropTypes.shape(AccessSessionProp.propType).isRequired,
  createInput: PropTypes.func.isRequired,
  createUserMultiple: PropTypes.func.isRequired,
  selectMultiple: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(PropTypes.shape(TeamProp.propType)).isRequired,
  selectTags: PropTypes.func.isRequired,
};

TabTarget.defaultProps = {
};

export default translate(TabTarget);
